import { ReactNode } from 'react';
import { classNames } from '@progress/kendo-react-common';
import styles from './Panel.module.scss';

export type PanelProps = {
    children?: ReactNode,
    className?: string
};

export const Panel = ({ children, className }: PanelProps) => (
    <div className={classNames(styles.panel, className)}>{children}</div>
);

export const PanelBody = ({ children, className }: PanelProps) => (
    <div className={classNames(styles.body, className)}>{children}</div>
);

export const PanelButtons = ({ children, className }: PanelProps) => (
    <div className={classNames(styles.buttons, className)}>{children}</div>
);

export const PanelHeader = ({ children, className }: PanelProps) => (
    <div className={classNames(styles.header, className)}>{children}</div>
);

export const PanelSubtitle = ({ children, className }: PanelProps) => (
    <div className={classNames(styles.subtitle, className)}>{children}</div>
);

export const PanelTitle = ({ children, className }: PanelProps) => (
    <div className={classNames(styles.title, className)}>{children}</div>
);

export const PanelLink = ({ children, className }: PanelProps) => (
    <div className={classNames(styles.link, className)}>{children}</div>
);
